import useLocalization from "@/hooks/useLocalization";
import useSettings from "@/hooks/useSettings";
import FormGroup from "@mui/material/FormGroup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { format } from "date-fns";
import { enUS } from "date-fns/locale";

export default function ReservationSettings() {
  const { adapterLocale, t } = useLocalization();
  const { settings, setFirstDayOfWeek } = useSettings();
  const baseDate = new Date(2021, 7, 1);

  const weekOptions = Array.from({ length: 7 }).map((_, index) => {
    const date = new Date(
      baseDate.getFullYear(),
      baseDate.getMonth(),
      baseDate.getDate() + index,
    );
    return {
      id: format(date, "EEEE", { locale: enUS }).toLowerCase(),
      label: format(date, "EEEE", { locale: adapterLocale }),
    };
  });

  return (
    <FormGroup>
      <Stack spacing={1} sx={{ marginTop: 2 }}>
        <Typography variant="body2">{t("settings:firstDayOfWeek")}</Typography>
        <Select
          size="small"
          value={settings?.firstDayOfWeek ?? "sunday"}
          onChange={(event) => setFirstDayOfWeek(event.target.value)}
        >
          {weekOptions.map(({ id, label }) => (
            <MenuItem key={id} value={id}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </Stack>
    </FormGroup>
  );
}
